import { FieldSelect } from '../../shared/FieldSelect';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import type { MainlineRowInput } from '@services/drbfm.mainline';
import { fields } from './fields';

export default function RowFieldsEditor({ value, onChange, disabled = false }: {
  value: MainlineRowInput; onChange: (value: MainlineRowInput) => void; disabled?: boolean;
}) {
  const { t } = useTranslation();
  const id = useId();
  const set = (key: string, text: string) => onChange({ ...value, fields: { ...value.fields,
    [key]: key.endsWith('_score') ? (text === '' ? null : Number(text)) : text } });
  return <div className="grid gap-3 md:grid-cols-2">
    {fields[value.kind].map(key => <label className="grid gap-1 text-sm" key={key} htmlFor={`${id}-${key}`}>
      {t(`drbfm.mainline.${key}`)}
      {key === 'countermeasure_type' || key === 'countermeasure_requirement'
        ? <FieldSelect id={`${id}-${key}`} disabled={disabled}
          value={String(value.fields[key] ?? (key === 'countermeasure_type' ? 'prevention' : 'pending'))}
          onValueChange={selected => set(key, selected)}
          options={(key === 'countermeasure_type' ? ['prevention', 'detection', 'mitigation'] : ['pending', 'required', 'not_required'])
            .map(option => ({ value: option, label: t(`drbfm.mainline.${option}`) }))} />
        : key.endsWith('_score') ? <Input id={`${id}-${key}`} type="number" min={1} max={10}
          value={String(value.fields[key] ?? '')} disabled={disabled} onChange={e => set(key, e.target.value)} />
          : <Textarea id={`${id}-${key}`} value={String(value.fields[key] ?? '')} disabled={disabled}
            onChange={e => set(key, e.target.value)} />}
    </label>)}
    <label className="grid gap-1 text-sm md:col-span-2">{t('drbfm.mainline.unknown')}
      <Textarea value={value.unknown_conditions.join('\n')} disabled={disabled}
        onChange={e => onChange({ ...value, unknown_conditions: e.target.value.split('\n').filter(Boolean) })} />
    </label>
    {value.kind === 'failure_mode' && <p className="text-sm text-muted-foreground md:col-span-2">{t('drbfm.mainline.scoreHint')}</p>}
  </div>;
}
